/**
 * About gold newsletter CTA (`.gold-section`). This is the about-page inline
 * newsletter block (not the shared black `Newsletter` section), so it is
 * converted here keeping the original grid ids and classes. The form validates
 * and shows the original success state client-side (no backend, per scope).
 */
import type { FC, FormEvent } from 'react'

import { useState } from 'react'

export const GoldenCta: FC = () => {
    const [email, setEmail] = useState('')
    const [submitted, setSubmitted] = useState(false)

    const onSubmit = (event: FormEvent) => {
        event.preventDefault()
        if (!email.trim()) return
        setSubmitted(true)
    }

    return (
        <div className='section gold-section'>
            <div className='container'>
                <div className='golden-cta-container'>
                    <div className='w-layout-grid grid-6-col-cta'>
                        <div id='w-node-_6bb5aeaf-6b14-3c04-4aac-2b4453187d3c-53187d38' className='fade-in-move-on-scroll'>
                            <h3 className='white-text no-margins'>Put your hands first at our premium and limited products</h3>
                        </div>
                        <div id='w-node-_6bb5aeaf-6b14-3c04-4aac-2b4453187d3f-53187d38' className='center-text'>
                            <div className='newsletter-email-section'>
                                <div className='form-block w-form'>
                                    {submitted ? (
                                        <div className='success-message gold w-form-done' style={{ display: 'block' }}>
                                            <div>Thank you! Your submission has been received!</div>
                                        </div>
                                    ) : (
                                        <form name='wf-form-Newsletter-Email' method='get' className='newsletter-form' onSubmit={onSubmit}>
                                            <div className='fade-in-move-on-scroll _100width'>
                                                <label htmlFor='Newsletter-Email-2' className='newsletter-field-label'>
                                                    Subscribe to our newsletter.
                                                </label>
                                            </div>
                                            <div className='fade-in-move-on-scroll _100width'>
                                                <input
                                                    className='newsletter-text-field white w-input'
                                                    maxLength={256}
                                                    name='Newsletter-Email-2'
                                                    placeholder='E-mail'
                                                    type='email'
                                                    id='Newsletter-Email-2'
                                                    value={email}
                                                    onChange={(event) => setEmail(event.target.value)}
                                                />
                                            </div>
                                            <div className='fade-in-move-on-scroll _100width'>
                                                <input type='submit' className='button subscribe-button w-button' value='SUBSCRIBE' />
                                            </div>
                                        </form>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
